import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

//send message
export const sendMessage = createAsyncThunk("sendMessage", async (data) => {
  try {
    const form = new FormData();
    if (data.attachment) {
      form.append("attachment", data.attachment);
    }
    if (data.type) {
      form.append("type", data.type);
    }
    form.append("message", data.message);
    form.append("sender_id", data.sender_id);
    form.append("receiver_id", data.receiver_id);
    form.append("conversation_id", data.conversation_id);

    const response = await instance.post(endpoints.sendMessage, form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    return {
      exception: error,
    };
  }
});

//get messages
export const getMessages = createAsyncThunk("getMessage", async (id) => {
  try {
    const response = await instance.get(endpoints.getMessages + id);
    return response;
  } catch (error) {
    
    return {
      exception: error,
    };
  }
});

//get conversation
export const getConversations = createAsyncThunk(
  "getConversations",
  async (id) => {
    try {
      const response = await instance.get(endpoints.getConversations + id);
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);
